import { render, staticRenderFns } from "./PeopleLayout.vue?vue&type=template&id=7903799d&scoped=true&"
import script from "./PeopleLayout.vue?vue&type=script&lang=js&"
export * from "./PeopleLayout.vue?vue&type=script&lang=js&"
import style0 from "./PeopleLayout.vue?vue&type=style&index=0&id=7903799d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7903799d",
  null
  
)

export default component.exports